import {ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {UserService} from "app/core/user/user.service";
import {ExtProfilesService} from "../../ext-profiles.service";
import {UntypedFormControl, UntypedFormGroup, Validators} from "@angular/forms";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import { IUser } from 'app/interfaces/IUser'

@UntilDestroy()
@Component({
    selector: 'app-generic-textbox',
    templateUrl: './generic-textbox.component.html',
    styleUrls: ['./generic-textbox.component.scss']
})
export class GenericTextboxComponent implements OnInit {

    cUser: IUser;
    @Input() keyname: string;
    @Input() curLang: string;
    @Input() displayDebug: false;

    public fGroup: UntypedFormGroup = new UntypedFormGroup({
        'keyValue': new UntypedFormControl('', Validators.required),
    });

    constructor(
        private userService: UserService,
        private extProfilesService: ExtProfilesService,
        private cdr: ChangeDetectorRef,
    ) {}

    ngOnInit(): void {
        this.userService.user$.pipe(untilDestroyed(this)).subscribe((aUser) => {

            this.cUser = aUser;
            this.fGroup.patchValue({'keyValue': aUser.extProfiles[this.keyname]}, {emitEvent: false});
            this.cdr.markForCheck();

        })

        this.fGroup.valueChanges.pipe(untilDestroyed(this)).subscribe(() => {
            this.extProfilesService.updateExtProfiles(this.keyname, this.fGroup.get('keyValue').value);
        })
    }


}
